<template>
    <div v-bind:class="{'effect-moveIn' : item.addedToCart, 'effect-moveOut' : item.removed }" class="basket-item-container col-12">
        <div class="row cart-item-header cart-item-discount-header">
            <span class="col-12 ">
                <span v-for='discount in item.appliedDiscounts'>
                    <span class="font-weight-bold">{{discount.name}}</span>
                    <span class="color-primary d-block">{{discount.description}}</span>
                </span>            
            </span>           
        </div>
        <div class="row">

            <div class="quantity col-6">
                <amz-spinner v-model="item.quantity" v-on:quantitychange="quantityChanged" v-bind:name="'itemquantity' + item.id">
                </amz-spinner>
            </div>

            <div class="remove subtotal text-right col-6" v-if="dishDiscountTotal >0">
                <span class="product-subtotal text-nowrap discounted">{{(dishTotal + dishDiscountTotal) | toCurrency}}</span>
                <input type="checkbox" class="d-none" name="removefromcart" v-bind:value="item.id" />
                <span class="icon-trash removefromcart" v-on:click="removeCartItem"></span>
                <div class="product-discount text-nowrap">
                    <span>{{dishTotal | toCurrency }}</span>
                </div>
            </div>

            <div class="remove subtotal text-right col-6" v-else>
                <span class="product-subtotal text-nowrap">{{dishTotal | toCurrency}}</span>
                <input type="checkbox" class="d-none" name="removefromcart" v-bind:value="item.id" />
                <span class="icon-trash removefromcart" v-on:click="removeCartItem"></span>
            </div>

        </div>

        <div class="row">
            <amz-cart-item-discount-group-child v-on:remove-cart-item="removeCartItem(item, $event)" v-on:cart-item-quantitychanged="quantitychanged(item, $event)" v-for="(item, index) in item.children" v-bind:item="item" v-bind:key="item.id"></amz-cart-item-discount-group-child>
        </div>
    </div>

</template>

<script>

    import { services } from '../Services/Services'
    import shoppingCartService from '../Services/ShopingCartService';
    import amzSpinner from './amz-spinner.vue';
    import amzCartItemDiscountGroupChild from './amz-cart-discount-group-child.vue';
    import translate from './translate';

    export default {

        props: { "item": Object },
        components: { amzSpinner, translate, amzCartItemDiscountGroupChild },
        methods: {
            /**
             * Returns the allergy, used to display the icon + name
             * @param {number} id - the allergy Id
             * @returns {object} - the requested allergy
             */
            getAllergy: function (id) {
                return services.getAllergy(id);
            },

            /**
             * Click handler for the remove cartitem button
             **/
            removeCartItem: function () {
                // raise event, amz-cart component is responsible for api interaction
                this.$emit('remove-cart-item', { item: this.item, el: this.$el });
            },

            /**
             * Quantity changed handler
             * @param {decimal} q - the quantity
             */
            quantityChanged: function (event) {
                this.$emit('cart-item-quantitychanged', { item: this.item, oldQ: event.oldValue, el: this.$el });
            }

        },
        computed: {
            /** Returns the total of the dish
             * @return {number} - the total of the dish
             **/
            dishTotal: function () {
              
                var total = this.item.subTotal.priceInclTax;

                for (var i in this.item.children) {
                    let child = this.item.children[i];
                    total += child.subTotal.priceInclTax;
                    if (child.children) {
                        for (var i2 in child.children) {
                            let grchild = child.children[i2];
                            total += grchild.subTotal.priceInclTax;
                        }
                    }
                }
                return total;
            },

            dishDiscountTotal: function () {
              
                var total = 0;

                if (this.item.discount) {
                    total += this.item.discount.priceInclTax;
                }
                               
                for (var i in this.item.children) {
                    let child = this.item.children[i];

                    if (child.discount)
                        total += child.discount.priceInclTax;

                    if (child.children) {
                        for (var i2 in child.children) {
                            let grchild = child.children[i2];
                            if(grchild.discount)
                                total += grchild.discount.priceInclTax;
                        }
                    }
                }
                return total;
            },
            rewardProductsCount: function () {
                return this.item.redeemedRewardPoints / 10;
            }

        }
    }


</script>



// WEBPACK FOOTER //
// Vue/Src/Components/amz-cart-discount-group-item.vue